export var LegacyPrivacyOptionInfoAdaptor = function(preferencesData) {
    var privacyOptionInfo = {};
    
    // Constructor
    if (preferencesData) {
        privacyOptionInfo.showContactInfo = preferencesData.showContactInfo;
        privacyOptionInfo.showContactInfoToFamilyAndFriends = preferencesData.showContactInfoToFamilyAndFriends;
        privacyOptionInfo.showContactInfoToFirstUpLine = preferencesData.showContactInfoToFirstUpLine;
        privacyOptionInfo.visibleInScannerLocator = preferencesData.visibleInScannerLocator;
        privacyOptionInfo.visibleInSponsorSearch = preferencesData.visibleInSponsorSearch;
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------

    return privacyOptionInfo;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/adaptors/legacyPrivacyOptionInfoAdaptor.js
// module id = 42
// module chunks = 0